/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import { Component, ViewChild } from '@angular/core';
import {ModalController, Nav, Platform} from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

// import firebase from 'firebase';
// import {firebaseConfig} from "../environments/firebase.config";
import {SessionService} from "../providers/session-service";
import {PageRefs} from "../shared/PageRefs";
import {OneSignal} from "@ionic-native/onesignal";


@Component({
  templateUrl: 'app.html',
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = PageRefs.home.name;

  pages: Array<{title: string, component: any}>;

  constructor(private platform: Platform,
              private statusBar: StatusBar,
              private modalCtrl: ModalController,
              private splashScreen: SplashScreen,
              private oneSignal: OneSignal,
              private session: SessionService) {

    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.initializeApp();

    });

    // used for an example of ngFor and navigation
    this.pages = [
      { title: 'Home', component: PageRefs.home.name },
    ];

  }

  initializeApp() {
    // firebase.initializeApp(firebaseConfig);
    this.session.init();
    this.initializePns();

    if (this.platform.is('android')) {
      this.statusBar.backgroundColorByHexString('#b30000');
    } else {
      this.statusBar.styleLightContent();
    }

    this.splashScreen.hide();
  }

  private initializePns() {
    this.oneSignal.startInit('13071f2c-6e74-4065-b632-9c0791f43b18', '516647356570');
    this.oneSignal.setLogLevel({
      logLevel: 3,
      visualLevel: 0
    });

    this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification);

    this.oneSignal.handleNotificationReceived().subscribe(() => {
      console.log('notification received');
      // this.badge.hasPermission().then((res) => {
      //   console.log('badge permission ' + res);
      //   this.badge.increase(1).then(() => {
      //     console.log('increased badge');
      //   });
      // });
    });

    this.oneSignal.handleNotificationOpened().subscribe((result) => {
      // do something when a notification is opened
      console.log('notification opened');

      let payload = result.notification.payload;
      if (payload) {
        let additionalData = payload.additionalData;

        let notificationType = additionalData['notificationType'];
        switch (notificationType) {
          case 100:
            this._handleAnnouncementNotification(additionalData);
            break;
        }
      }
    });

    this.oneSignal.endInit();
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  // region Notification Handlers

  private _mockAnnouncmentNotification() {
    let data = {};
    data['eventId'] = 'mwtb2018chatham';
    data['announcementId'] = 'msg03';

    this._handleAnnouncementNotification(data);
  }

  private _handleAnnouncementNotification(data: any) {
    let eventId = data['eventId'];
    let announcementId = data['announcementId'];
    let title = data['title'];

    this.session.userId$.subscribe(uid => {
      if (uid) {
        let data = {};
        data[PageRefs.announcementFull.params.eventId] = eventId;
        data[PageRefs.announcementFull.params.announcementId] = announcementId;
        data[PageRefs.announcementFull.params.title] = title;

        this.modalCtrl.create(PageRefs.announcementFull.name, data).present();
      }
    });
  }

  // endregion
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts